export default __webpack_public_path__ + "static/media/2.64512bb8.jpg";